import React from 'react'

const ChartHeader = () => {
  return (
    <div>ChartHeader</div>
  )
}

export default ChartHeader